import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.ADVERTISER};
const path = "/advertiser"

export const getLeads = async () => {
  return await axiosInstance(options).get(`${path}/lead/get-leads`);
}

export const changeStatus = async (values) => {
  return await axiosInstance(options).post(`${path}/lead/change-lead-status`,values);
}



export const getLeadsCustomer = async () => {
  return await axiosInstance(options).get(`${path}/lead/get-customers`);
}









